export const IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS';
export const ADD_STAFF_DIALOG = 'ADD_STAFF_DIALOG';
export const STAFF_MEMBER_CHANGE = 'STAFF_MEMBER_CHANGE';
export const RESET_STAFF_DATA = 'RESET_STAFF_DATA';
